var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"visible":this.value,"title":"Upload Custom Testcase","centered":"","afterClose":this.close},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('Uploader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }